import { render } from "./addStock.vue?vue&type=template&id=b7ef04c6"
import script from "./addStock.vue?vue&type=script&lang=js"
export * from "./addStock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__